import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["interval-length"]!;

export function Body() {
  return (
    <>
      <p>
        Short and very hard, or longer and a little less hard? A Norwegian study compared three
        interval sessions where the athletes worked as hard as they could hold, and found that
        the hardest one was not the most effective.
      </p>

      <h2>What the researchers did</h2>
      <p>
        Thirty-five trained recreational cyclists were split into four groups for seven weeks.
        One group only trained at low intensity. The three others did two interval sessions a
        week, plus easy training: 4 × 4 minutes, 4 × 8 minutes or 4 × 16 minutes. They were told
        to ride each interval at the highest intensity they could sustain for the whole session.
      </p>
      <p>
        That made the short intervals hardest. The 4 × 4 group worked at about 94 percent of
        their maximum heart rate, the 4 × 8 group at about 90 percent and the 4 × 16 group at
        about 88 percent.
      </p>

      <h2>What they found</h2>
      <p>
        The 4 × 8 group improved most. Across maximal oxygen uptake, power at maximal oxygen
        uptake and power at a set lactate level, they improved by 11.4 percent on average. The
        other groups improved by 4 to 6 percent.
      </p>
      <p>
        In other words, 32 minutes of work at about 90 percent of maximum heart rate gave more
        than 16 minutes at about 95 percent, even though it felt less hard.
      </p>

      <h2>What it means for you</h2>
      <p>
        Harder is not automatically better. Intervals of several minutes at a hard but
        controlled effort, where you can hold the pace through every repetition, can give more
        than short intervals you only just survive.
      </p>
      <p>
        If the last repetitions are clearly slower than the first ones, the session was probably
        too hard for its purpose.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The participants were cyclists, not runners, and the study lasted seven weeks. The 11.4
        percent is a combined result across three measures, not a promise of a faster race
        time. And 4 × 8 minutes is not the right session for every runner or every phase of
        training.
      </p>

      <h2>How we use it</h2>
      <p>
        Interval sessions in PX7 Training have a target and a range for each work period, so you
        can hold the pace through all of them. The purpose of the session and the total time
        decide the intensity, not a wish to make every session as hard as possible.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Seiler et al. (2013), Adaptations to aerobic interval training: interactive effects of
          exercise intensity and total work duration.{" "}
          <a href="https://doi.org/10.1111/j.1600-0838.2011.01351.x">Scandinavian Journal of Medicine & Science in Sports</a>.
        </li>
      </ul>
    </>
  );
}
